module.exports = __webpack_public_path__ + "img/icon_win.86bc143e.png";